module.exports = __webpack_public_path__ + "static/media/image_logo_pinjia_color.792f4d18.png";